const feedback = {
    S00: '#E0F6D0',
    S02: '#A2DD78',
    S03: '#66BC29',
    W00: '#FFF3CC',
    W01: '#FFD766',
    W02: '#FFB60F',
    E00: '#FD8888',
    E01: '#e64445',
};

export default feedback;
